

import anime from 'animejs';

export default class{
    /**
     * loading要素の初期設定等を行うコンストラクタ
     * DOM生成時に即時実行
     */
    constructor() {
        this.mask = document.querySelector('#js-loading__mask')
        this.elements = "#js-loading__mask .js-loading__element"

        this.logoAnimation_elm = document.querySelector('.js-loading__logo')
        this.loading_elements = document.querySelectorAll(this.elements)
        
        if(process.env.MIX_DISP_LOADING == "false" && process.env.NODE_ENV == "development"){
            this.mask.style.display = "none" 
        }
    }
    /**
     * 初期表示前に1度だけ実行
     * @param {*} data 
     */
    beforeOnce(data){
        

        return new Promise(resolve => {

            let timeline = anime.timeline();
            timeline
            .add({
                targets: ".js-loading__logo img",
                opacity: [0,1],
                translateY: ["10px",0],
                easing: 'easeInOutSine',
                duration : 1000,
                begin:() =>{
                    this.logoAnimation_elm = document.querySelector('.js-loading__logo')
                    if(this.logoAnimation_elm){
                        this.logoAnimation_elm.style.opacity = 1
                    }
                },
                complete: () =>{
                    resolve();
                }
            // 初期読み込み時の待ち時間
            },600)
            .add({
                targets: ".js-loading__logo img",
                opacity: [1,0],
                translateY: [0,"-10px"],
                easing: 'easeInOutBack',
                duration : 1000
            // 初期読み込み時の待ち時間
            },2500)
            .add({
                targets: ".js-loading__logo",
                opacity: [1,0],
                easing: 'easeOutQuart',
                duration : 1000,
                complete: () => {
                    this.logoAnimation_elm = document.querySelector('.js-loading__logo')

                    if(this.logoAnimation_elm){
                        this.logoAnimation_elm.style.opacity = 0
                    }
                }
            // 初期読み込み時の待ち時間
            },"-=500")
        })
    }
    /**
     * 初期表示時に1度だけ実行
     * @param {*} data 
     */
    once(data){
        return new Promise(resolve => {
            resolve();
        })
    }
    /**
     * 初期表示完了後に1度だけ実行
     * @param {*} data 
     */
    afterOnce(data){

        return new Promise(resolve => {
            const timelime = anime.timeline()
            timelime
            .add({
                targets: this.elements,
                translateY : [0,"100%"],
                easing: 'easeInOutExpo',
                duration : 1000,
                delay: (el,i) => {
                    return  50 * i
                },
                complete : () => {
                    
                    resolve();
                }
            })
        });
    }
    /**
     * 次ページ読み込み前に実行
     * @param {*} data 
     */
    beforeLeave(data){
        return new Promise(resolve => {
            resolve();
        })
    }
    /**
     * 次ページ読み込み時に実行
     * @param {*} data 
     */
    leave(data){

        return new Promise(resolve => {
            
            data.next.container.style.opacity = 0;
            const timelime = anime.timeline()
            timelime
            .add({
                targets: this.elements,
                scaleX:{
                    value:1,
                    duration:0
                },
                translateY : ["100%",0],
                easing: 'easeInOutExpo',
                duration : 1000,
                delay: (el,i) => {
                    return  50 * i
                },
                complete : () => {
                    resolve();
                }
            })

        });
    }
    /**
     * 次ページ読み込み完了後に実行
     * @param {*} data 
     */
    afterLeave(data){
        return new Promise(resolve => {
            resolve();
        })
    }
    /**
     * 次ページ表示前に実行
     * @param {*} data 
     */
    beforeEnter(data){
        return new Promise(resolve => {
            resolve();
        })
    }
    /**
     * 次ページ表示時に実行
     * @param {*} data 
     */
    enter(data){
        return new Promise(resolve => {
            resolve();
        })
    }
    /**
     * 次ページ表示完了後に実行
     * @param {*} data 
     */
    afterEnter(data){
        return new Promise(resolve => {
            resolve();
        })
    }
    /**
     * すべて完了後に実行
     * @param {*} data 
     */
    after(data){

        return new Promise(resolve => {

            const timelime = anime.timeline()
            timelime
            .add({
                targets: this.elements,
                scaleX : [1,0],
                easing: 'easeInOutExpo',
                duration : 1000,
                delay: (el,i) => {
                    return  50 * i
                },
                begin: () => {
                    this.initialScroll ()
                    data.next.container.style.opacity = 1;
                },
                complete : (el) => {
                    
                    resolve();
                }
            })
        });
    }
    initialScroll (){
        if( location.hash == "" ){
            window.scrollTo(0,0);
        }else{
            let digit = location.hash.replace(/^#/,"");
            let anchor = document.getElementById( digit );
            if ( !anchor ) return;
            
            if(anchor){
                const rect = anchor.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                let top = rect.top + scrollTop;
                const header = document.querySelector('[data-header]');
                if(header){
                    if(header){
                        top = top - header.clientHeight;
                    }
                }
                window.scrollTo(0,top);
            }
            
        }
    }
}